import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { Lot } from "../../models/lot.model";
import { LotFacadeService } from "./lot-facade.service";

@Injectable({ providedIn: "root" })
export class LotStoreService extends EntityStoreService<
  Lot,
  EntityMetadata,
  LotState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
    });
  }
}

export interface LotState extends EntityStoreState<LotFacadeService> {}
